import { useGlobalContext } from '../context/stateContext';

const RoleBasedComponent = ({ allowedRoles, children,renderComponent, fallback = null }) => {
  const { activeSession } = useGlobalContext();
  const userRole = activeSession?.user?.role;

  const content = renderComponent ? renderComponent() : children;

  if(allowedRoles.length === 0) {
    return content
  }else{
    if (allowedRoles.includes(userRole)) {
      return content;
    }
  } 

  return fallback;
};

export default RoleBasedComponent;